import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './stylesheets/index.scss';
import Data from './data/places.json';
import MapPath from './assets/deutschlandkarte-v01.svg';
import MapBG from './assets/deutschlandkarte-bg.jpg';

function Place(props) {
  const placeCssClasses = ["place"];
  const contentCssClasses = ["place-content"];
  const [placeState, setPlaceState] = useState(false);

  if (placeState === true) placeCssClasses.push("is-active");
  if (placeState === true) contentCssClasses.push("fade-in");
  if (placeState === false) contentCssClasses.push("fade-out");
  
  function clickHandler() {
    if (placeState === true) {
      setPlaceState(false);
    } else {
      setPlaceState(true);
    }
  }
  
  return (
    <div className={placeCssClasses.join(" ")}>
      <div className="place-area" onClick={() => clickHandler()} style={{left: props.posLeft + '%', top: props.posTop + '%'}}>
        {/* P */}
      </div>

      <div className={contentCssClasses.join(" ")}>
        <div className="place-content-inner">

          {props.title ? <h2 dangerouslySetInnerHTML={{__html:props.title}}></h2> : null}
          
          {props.school ? <h3 className="caption">Schule</h3> : null}
          {props.school ? 
            <p className="data">
              {props.school}
            </p>
          : null}
          
          {props.location ? <h3 className="caption">Standort</h3> : null}
          {props.location ? 
            <p className="data">
              {props.location}
            </p>
          : null}
          
          {props.schoolClass ? <h3 className="caption">Klasse</h3> : null}
          {props.schoolClass ? 
            <p className="data">
              {props.schoolClass}
            </p>
          : null}
          
          {props.teachingField ? <h3 className="caption">Unterrichtsfeld</h3> : null}
          {props.teachingField ? 
            <p className="data">
              {props.teachingField}
            </p>
          : null}
          
          {props.description ? <h3 className="caption">Beschreibung</h3> : null}
          {props.description ? <p className="data" dangerouslySetInnerHTML={{__html:props.description}}></p> : null}

          {props.moreLink ? 
            <p className="data">
              <a className="more-link" target="_top" title="" href={props.moreLink}>
                Zum Wettbewerbsbeitrag
              </a>
            </p>
          : null}

          {props.image ? <img className="content-image" alt="" src={props.image} /> : null}
          
          <button className="button-close" onClick={() => clickHandler()}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.28 37.28">
              <line x1="0.35" y1="0.35" x2="36.93" y2="36.93" strokeLinecap="butt" />
              <line x1="0.35" y1="36.93" x2="36.93" y2="0.35" strokeLinecap="butt" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

function renderPlaces() {
  
  let posLeft, posTop, title, description, image, school, schoolClass, teachingField, location, moreLink;
  
  return (
    <div className="places-wrapper">
     <img className="map-bg" src={MapBG} />
     <img className="map-path" src={MapPath} />
      {
        Data.Places.map((place, i) => {  
          place.Position.map((placePos) => {
            return (
              posLeft = placePos.Left,
              posTop = placePos.Top
            );
          })
          place.Content.map((placeCont) => {
            return (
              title = placeCont.Title,
              description = placeCont.Description,
              image = placeCont.Image,
              school = placeCont.School,
              schoolClass = placeCont.SchoolClass,
              teachingField = placeCont.TeachingField,
              location = placeCont.Location,
              moreLink = placeCont.MoreLink
              );
          })
          return (
            <Place posLeft={posLeft} posTop={posTop} title={title} description={description} image={image} school={school} schoolClass={schoolClass} teachingField={teachingField} location={location} moreLink={moreLink} key={i} />
          );
        })
      }
    </div>
  );
}

class Map extends React.Component {
  render() {
    return (
      <div className="map">
        {renderPlaces()}
      </div>
    );
  }
}

// ========================================

ReactDOM.render(
  <Map />,
  document.getElementById('root')
);
